import { render, staticRenderFns } from "./student-main.vue?vue&type=template&id=4175325f"
import script from "./student-main.vue?vue&type=script&lang=js"
export * from "./student-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports